export default __webpack_public_path__ + "static/media/DigiJag-vit.1c4ec41a.svg";